module.exports = __webpack_public_path__ + "f04dda74a3898e7356693952802ed335.pdf";